import { render, staticRenderFns } from "./PinMessagesV2.vue?vue&type=template&id=71e1354e"
import script from "./PinMessagesV2.vue?vue&type=script&lang=js"
export * from "./PinMessagesV2.vue?vue&type=script&lang=js"
import style0 from "./PinMessagesV2.vue?vue&type=style&index=0&id=71e1354e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports